<script setup lang="ts">
import { Cake, Mail, MapPin, UserRound, UsersRound } from 'lucide-vue-next'

import type { Component } from 'vue'
import FieldRow from '../FieldRow.vue'
import useBrandAppConfig from '../../composables/useBrandAppConfig'
import { COMPLETION_FIELDS, type CompletionFieldId } from '../../lib/brandAppContract'

const { t } = useI18n()
const { completionFields, setCompletionFields } = useBrandAppConfig()

const FIELD_ICONS: Record<CompletionFieldId, Component> = {
  firstName: UserRound,
  lastName: UserRound,
  email: Mail,
  gender: UsersRound,
  birthdate: Cake,
  postalCode: MapPin
}

const isAsked = (id: CompletionFieldId) => completionFields.value.includes(id)

const isLastAsked = (id: CompletionFieldId) => completionFields.value.length === 1 && isAsked(id)

const toggleField = (id: CompletionFieldId, asked: boolean) => {
  const next = COMPLETION_FIELDS.map((field) => field.id).filter((fieldId) =>
    fieldId === id ? asked : isAsked(fieldId)
  )
  setCompletionFields(next)
}
</script>

<template>
  <div class="flex flex-col gap-3">
    <p class="text-foreground text-sm font-medium">{{ t('pages.loyaltySupports.webapp.editor.completion.title') }}</p>
    <FieldRow
      v-for="field in COMPLETION_FIELDS"
      :key="field.id"
      :label="field.label"
      :label-for="`brandApp.completionFields.${field.id}`"
    >
      <template #leading>
        <span class="bg-muted flex size-8 shrink-0 items-center justify-center rounded-lg">
          <component :is="FIELD_ICONS[field.id]" class="text-primary size-4" />
        </span>
      </template>
      <Switch
        :id="`brandApp.completionFields.${field.id}`"
        :model-value="isAsked(field.id)"
        :disabled="isLastAsked(field.id)"
        @update:model-value="toggleField(field.id, $event)"
      />
    </FieldRow>
  </div>
</template>
